import { BOX_TYPE_FOR_SELECTION, SPECIAL_PRODUCT_BUNDLE_ADDON_TYPES } from 'swag-common/constants/product.constants';
export function isBundle(product) {
  var _product$bundleConten;
  return Boolean((product === null || product === void 0 ? void 0 : (_product$bundleConten = product.bundleContent) === null || _product$bundleConten === void 0 ? void 0 : _product$bundleConten.length) > 0);
}
export function isBundleItem(item) {
  return Boolean(item === null || item === void 0 ? void 0 : item.bundleCustomProductId);
}
export function isBundleAddon(product) {
  return SPECIAL_PRODUCT_BUNDLE_ADDON_TYPES.includes(product === null || product === void 0 ? void 0 : product.specialProductType);
}
export function isPackageProduct(product) {
  return BOX_TYPE_FOR_SELECTION.includes(product === null || product === void 0 ? void 0 : product.specialProductType);
}